module.exports = __webpack_public_path__ + "media/assets/images/blog/customerize_7182-small-63387800f771ccd68a55ce5920d3f2a9.jpg";